<template>
  <div class="loading-animation-container">
    <div class="animation-container">
      <div class="loading-animation">
        <DotLottieVue style="height: 200px; width: 200px" autoplay loop src="/assets/loader.lottie" />
        <h4>{{ loadingTitleText }}</h4>
        <h5 v-if="loadingDescription">
          {{ loadingDescription }}
        </h5>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import { DotLottieVue } from "@lottiefiles/dotlottie-vue";

export default defineComponent({
  name: "PageLoading",
  components: { DotLottieVue },
  props: {
    loadingTitle: { type: String, default: "" },
    loadingDescription: { type: String, default: "" },
  },
  setup(props) {
    const { t } = useI18n();

    const loadingTitleText = computed(() => (props.loadingTitle ? props.loadingTitle : t("loading")));

    return {
      t,
      loadingTitleText,
    };
  },
});
</script>

<style scoped>
.loading-animation-container {
  padding: 16px;
  height: calc(100vh - 32px);
  display: flex;
  flex-direction: column;
}

.animation-container {
  justify-content: center;
  align-items: center;
  flex: 1;
  display: flex;
}

.animation-container h4 {
  color: var(--Typography-Text-1);
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px;
  margin: auto;
}

.animation-container h5 {
  color: var(--Typography-Text-2);
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px;
  margin: auto;
}

.loading-animation {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;
  padding-bottom: 80px;
}
</style>
